import { Component, Ref } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/buttons/ExpandButton.css'
import Touchable from 'components/utils/Touchable'
import Icon from 'components/atoms/Icon'

export type ExpandButtonProps = {
  isExpanded: boolean
  buttonRef?: Ref<HTMLButtonElement>

  onTap?: HammerListener
  onClick?: () => void
}

class ExpandButton extends Component<ExpandButtonProps, {}> {
  render () {
    const {
      isExpanded, buttonRef,
      onClick, onTap,
    } = this.props

    const iconWrapperClass = cn(styles.iconWrapper, {
      [styles.expanded]: isExpanded,
    })

    return (
      <Touchable onTap={ onTap } childRef={ buttonRef } >
        <button className={ styles.expandButton } onClick={ onClick }>
          <div className={ iconWrapperClass }>
            <Icon kind='chevron-secondary' />
          </div>
        </button>
      </Touchable>
    )
  }
}

export default ExpandButton
